/* eslint key-spacing: 'off', comma-spacing: 'off' */
//import VariableSelection from '@/bo/VariableSelection';
import VariableGroup from '@/bo/VariableGroup';
import VariableObject from '@/bo/VariableObject';
import store from '@/store';

export default function VariableSelection(variable, type, include, group, categories) {
    this.include = include === false ? false : true;
    this.variable = variable ? variable : new VariableObject();
    if (!this.variable.isSelected())
        variable = new VariableObject(this.variable.variable, this.variable.variableTitle);
    this.type = type;   //variable, year, or location
    this.group = group ? group : new VariableGroup();
    this.categories = categories === undefined || categories === null ? [] : categories;
};

VariableSelection.newLocation = function () {
    return new VariableSelection(new VariableObject('location', 'Location'), 'location', /*include=*/true);
};

VariableSelection.newYear = function () {
    return new VariableSelection(new VariableObject('year', 'Year'), 'year', /*include=*/true);
};

VariableSelection.newIncluded = function () {
    return new VariableSelection(new VariableObject(), 'variable', /*include=*/true);
};

VariableSelection.newNotIncluded = function () {
    let variableObject = new VariableObject();
    return new VariableSelection(variableObject, 'variable', /*include=*/false);
};

VariableSelection.createFromVariable = function (variableObject) {
    var variableYear = store.state.dataLists.variableDataLists.variableYears.filter(v => v.variable === variableObject.variable)[0];
    var theVariable = VariableObject.createFromVariable(variableObject);
    var theGroupSource = store.state.dataLists.variableDataLists.groups.filter(g => g.groupId === variableYear.groupId)[0];
    var theVariableGroup = new VariableGroup(theGroupSource.groupId, theGroupSource.groupLabel);
    var selection = new VariableSelection(theVariable, 'variable', /*include=*/true, theVariableGroup);
    return selection;
};

VariableSelection.createFromVariableSelection = function (v) {
    return new VariableSelection(VariableObject.createFromVariable(v.variable), v.type, v.include, VariableGroup.createFromVariableGroup(v.group), v.categories);
};

VariableSelection.prototype.getType = function () { return this.type };
VariableSelection.prototype.setLevels = function (categories) {
    this.categories = categories;
};

VariableSelection.prototype.copy = function () {
    return new VariableSelection(VariableObject.copy(this.variable), this.type, this.include, VariableGroup.copy(this.group), this.categories);
};

VariableSelection.prototype.groupToString = function () {
    if (!this.include)
        return '';
    return this.group.title !== null ? this.group.title : this.variable.variableTitle;
};
VariableSelection.prototype.toString = function () {
    if (!this.include)
        return '';
    //return this.variable !== null && this.variable.title !== null ?
    //  this.variable.title :
    //  (this.group.title !== null ? this.group.title : '');
    var groupTitle = this.group.title !== null ? this.group.title + ': ' : '';
    return this.variable === null ? '' : groupTitle + this.variable.toString();
};
VariableSelection.prototype.hasASelectedVariable = function () {
    return this.include && this.type === 'variable' && this.variable && this.variable.variable;
};

VariableSelection.prototype.isSelected = function () {
    if (!this.type)
        return false;
    if (this.type !== 'variable')
        return true;
    if (!this.variable)
        return false;
    return this.variable.isSelected();
};

VariableSelection.prototype.getVariableName = function () {
    return this.include && this.Variable !== null && this.variable.variable !== null ? this.variable.variable : null;
};

VariableSelection.prototype.isNotIncludedOrSelected = function () {
    let results = !this.include || this.isSelected();
    return results;
    //return !this.include || this.isSelected();
};

